var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BackBox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intro-Copy",
    transform: "translate(-16, -110)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,110 C44.418278,110 48,113.581722 48,118 L48,134 C48,138.418278 44.418278,142 40,142 L24,142 C19.581722,142 16,138.418278 16,134 L16,118 C16,113.581722 19.581722,110 24,110 L40,110 Z M32.8256369,118 L31.2825645,119.539724 L36.6455448,124.889041 L23.1831756,124.889041 L23.1831756,127.110959 L36.6455448,127.110959 L31.2825645,132.474073 L32.8256369,134 L40.8256369,126 L32.8256369,118 Z",
    id: "BackBox",
    transform: "translate(32, 126) scale(-1, 1) translate(-32, -126)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBox);
export default __webpack_public_path__ + "static/media/BackBox.d3c386902b485fc214bce34f5f1d70fc.svg";
export { ForwardRef as ReactComponent };